export default __webpack_public_path__ + "static/media/Kan.791b4d9d.mp4";